export default class HeaderSearch {
  constructor(el) {
    this.$el = $(el);
    this.$form = this.$el.find('[data-js-header-search]')
    this.$content = this.$el.find('[data-js-content]')
    this.$wrap = this.$el.find('[data-js-wrap]')
    this.$input = this.$el.find('[data-js-search-input]')
    this.triggerList = document.querySelectorAll('[data-js-header-search-trigger]')
    this.$closeTrigger = this.$el.find('[data-js-close]')
    this.$count = this.$el.find('[data-js-result-count]')
    this.$countWrap = this.$el.find('.header-search__text')
    this.init();
  }

  init({$el, $input, triggerList, $closeTrigger, $form, $count, $content, $wrap, $countWrap} = this){
    const $this = this;
    triggerList.forEach((trigger) => {
      $(trigger).on('click', e =>{
        e.preventDefault()
        $el.addClass('active')
      })
    })
    $closeTrigger.on('click', e => {
      e.preventDefault()
      $el.removeClass('active')
      $input.val('')
    })

    $input.on('input', e => {
      const curVal = e.target.value

      if (curVal.length > 2) {
        $.ajax({
          type:'POST',
          url: $form.attr('data-api'),
          dataType:'json',
          data: {
            q: curVal
          },
          success: function (data) {
            if (data.success) {
              let countRes = 0
              if (data.results.length > 0) {
                data.results.forEach((item) => {
                  countRes += item.list.length
                })
                $countWrap.removeClass('hidden')
                $count.text(countRes)
                $content.html($this.generateResultTemplate(data.results))
              } else {
                $countWrap.addClass('hidden')
                $content.html('<p class="header-search__text">По вашему запросу ничего не найдено</p>')
              }
              $wrap.removeClass('hidden')
            }
          },
          error: function (data) {
            console.log(data)
            $wrap.addClass('hidden')
          }
        });
      }
    })

    document.addEventListener('click', function (event) {
      const target = event.target.closest('.header');

      if (!target) {
        $el.removeClass('active')
        $input.val('')
      }
    });

    document.addEventListener('scroll', function (event) {
      if ($el.hasClass('active')) {
        $el.removeClass('active')
        $input.val('')
      }
    });
  }

  generateResultTemplate(data) {
    const getResultItemHtml = (item) => {
      const {name, link} = item
      return `<a class="header-search__results-link" href="${link}">${name}</a>
    `.trim()
    }

    const getResultListHtml = (data) => `
      <ul class="header-search__results-list">
        <li>${data.map(item => getResultItemHtml(item)).join('').trim()}</li>
      </ul>
    `.trim()

    const getResultHtml = (data) => {
      const {name, list} = data

      return `<div class="header-search__results">
                <p class="header-search__results-title">${name}</p>
                ${getResultListHtml(list)}
             </div>
    `.trim()
    }

    return data.map(item => getResultHtml(item)).join('').trim()
  }
}
